/*global $, document, window, setTimeout, alert, FG, confirm, location, FGT_CONFIG, console, navigator*/
(function () {
    "use strict";
    FG.Mobile = {
        init: function () {
            this.Android();
            this.BlackBerry();
            this.iOS();
            this.Opera();
            this.Windows();
            this.any();
        },
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
            var self = this;
            return (self.Android() || self.BlackBerry() || self.iOS() || self.Opera() || self.Windows());
        }
    };
}());